import api from "api/api";

export const getStatsHistorySalaryByBranchesExpDomainQuery = async ({
  experience,
  domain_ids,
  branch_ids,
}) => {
  const domainIdsParam = domain_ids?.length
    ? `&domain_id=${domain_ids.join("&domain_id=")}`
    : "";
  return await api.get(
    `/datatrack/salary/history/stats?experience=${experience}${domainIdsParam}&branch_ids=${branch_ids}`
  );
};

export const getStatsHistorySalaryByPersonIdQuery = async ({
  id,
  experience,
  branch_id,
}) =>
  await api.get(
    `/datatrack/salary/person/${id}/statistics?experience=${experience}&branch_id=${branch_id}`
  );

export const getSalaryCoefPosWarning = async ({
  person_id,
  salary,
  syntec_coef,
  scope,
}) => {
  const params = new URLSearchParams({ scope });

  salary && params.append("salary", salary);
  syntec_coef && params.append("syntec_coef", syntec_coef);

  return api.get(
    `/datatrack/salary/person/${person_id}/warning?${params.toString()}`
  );
};
